export default __webpack_public_path__ + "static/media/ERC721.0ffbd4f5.jpg";